import "./LeftBar.css";
import "../css/common.css";

export function LeftBar() {
	return <div id="left-bar">
		<div className="content">
			<div className="label">Scroll down</div>
			<div className="line"/>
		</div>
	</div>
}
